import { SVGAttributes } from 'react';
import { twMerge } from 'tailwind-merge';

function Phone({ width = 16, height = 16, color = '#00DA6B', className, ...rest }: SVGAttributes<SVGElement>) {
  return (
    <svg
      aria-hidden="true"
      focusable="false"
      {...rest}
      className={twMerge('', className)}
      width={width}
      height={height}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        opacity={0.12}
        d="M11.78 10.445l.944.236c.75.188 1.276.861 1.276 1.634 0 .93-.756 1.696-1.682 1.605-1.707-.166-3.23-.591-4.547-1.253a9.808 9.808 0 01-4.438-4.438C2.671 6.912 2.246 5.39 2.08 3.682 1.99 2.756 2.754 2 3.685 2c.773 0 1.447.526 1.634 1.276l.236.943c.136.546.205.82.2 1.08a2 2 0 01-.365 1.123c-.15.214-.367.394-.798.755L3.333 8.23a9.808 9.808 0 004.438 4.438l1.052-1.259c.36-.431.541-.647.755-.798a2 2 0 011.122-.366c.262-.003.535.065 1.08.201z"
        fill={color}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1.582 3.73C1.46 2.479 2.493 1.5 3.685 1.5c1.002 0 1.876.682 2.12 1.655l.235.943.016.065c.121.483.204.816.2 1.144a2.5 2.5 0 01-.457 1.403c-.19.268-.453.489-.835.808l-.052.043-.948.793a9.265 9.265 0 003.682 3.682l.793-.948.043-.052c.32-.382.54-.646.808-.835a2.5 2.5 0 011.403-.457c.328-.004.66.079 1.144.2l.065.016.943.236a2.185 2.185 0 011.655 2.12c0 1.19-.977 2.224-2.23 2.102-1.76-.172-3.344-.611-4.724-1.305a10.307 10.307 0 01-4.66-4.66c-.693-1.379-1.132-2.962-1.304-4.722zm6.99 8.758c1.12.48 2.388.797 3.794.935.599.058 1.134-.438 1.134-1.108 0-.543-.37-1.017-.897-1.149l-.943-.236c-.574-.143-.772-.188-.952-.186a1.5 1.5 0 00-.842.274c-.148.104-.28.258-.66.711l-.634.759zm-5.06-5.06l.759-.634c.453-.38.606-.512.71-.66a1.5 1.5 0 00.275-.842c.002-.18-.043-.378-.186-.952l-.236-.943a1.185 1.185 0 00-1.15-.897c-.669 0-1.165.535-1.107 1.134.138 1.406.455 2.674.935 3.794z"
        fill={color}
      />
    </svg>
  );
}

export default Phone;
